import { createFileRoute, notFound } from "@tanstack/react-router";
import { CIVILREG_QA, CIVILREG_QA_BY_SLUG, CIVILREG_REVIEWED_ISO, CIVILREG_REVIEWED_TH } from "@/data/civilreg/questions";
import { ClusterQaDetail, clusterQaDetailHead, type ClusterQaMeta } from "@/lib/qa/cluster-pages";

const M: ClusterQaMeta = { base: "/civilreg", label: "ทะเบียนราษฎรและครอบครัว", reviewedIso: CIVILREG_REVIEWED_ISO, reviewedTh: CIVILREG_REVIEWED_TH };

export const Route = createFileRoute("/civilreg/q/$slug")({
  loader: ({ params }) => { if (!CIVILREG_QA_BY_SLUG[params.slug]) throw notFound(); return { slug: params.slug }; },
  head: ({ loaderData }) => clusterQaDetailHead(M, loaderData ? CIVILREG_QA_BY_SLUG[loaderData.slug] : undefined),
  component: Page,
});

function Page() {
  const { slug } = Route.useLoaderData();
  const qa = CIVILREG_QA_BY_SLUG[slug];
  if (!qa) throw notFound();
  return <ClusterQaDetail m={M} qa={qa} all={CIVILREG_QA} />;
}
